import { render } from "./NFTCard2.vue?vue&type=template&id=6ee83045&scoped=true&ts=true"
import script from "./NFTCard2.vue?vue&type=script&lang=ts"
export * from "./NFTCard2.vue?vue&type=script&lang=ts"

import "./NFTCard2.vue?vue&type=style&index=0&id=6ee83045&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee83045"]])

export default __exports__